module.exports = __webpack_public_path__ + "img/BG6-icon.0e666fad.png";